import React from 'react';
import {
  Crown, Heart, TrendingUp, Users, Leaf, Shield,
  LayoutGrid, Wifi, Lightbulb, Landmark, GraduationCap, Target
} from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const PillarsSection = () => {
  const { t } = useLanguage();

  const icons = [
    Crown, Heart, TrendingUp, Users, Leaf, Shield,
    LayoutGrid, Wifi, Lightbulb, Landmark, GraduationCap, Target
  ];

  const pillars = t('pillars.items');

  return (
    <section
      id="pillars"
      data-testid="pillars-section"
      className="py-24 md:py-32 bg-[#F9FAFB]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-12 h-[2px] bg-[#C9A84C]" />
            <span className="text-[#C9A84C] font-semibold text-sm tracking-wider uppercase">
              Fundamentos
            </span>
            <div className="w-12 h-[2px] bg-[#C9A84C]" />
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#1A1F4B] mb-4">
            {t('pillars.title')}
          </h2>
          <p className="text-[#1F2937]/70 max-w-2xl mx-auto">
            {t('pillars.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {pillars.map((pillar, index) => {
            const Icon = icons[index];
            return (
              <div
                key={index}
                className="bg-white p-8 border border-gray-100 hover:border-[#C9A84C] hover:shadow-xl transition-all duration-300 group h-full flex flex-col relative overflow-hidden"
                data-testid={`pillar-${index}`}
              >
                <div className="absolute top-4 right-4 text-5xl font-heading font-bold text-[#F3F4F6] group-hover:text-[#C9A84C]/10 transition-colors">
                  {String(index + 1).padStart(2, '0')}
                </div>
                <div className="w-12 h-12 bg-[#1A1F4B] flex items-center justify-center mb-6 group-hover:bg-[#C9A84C] transition-colors">
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-bold text-[#1A1F4B] text-lg mb-2">{pillar.name}</h3>
                <p className="text-[#1F2937]/60 text-sm flex-grow">{pillar.desc}</p>
                <div className="absolute bottom-0 left-0 w-full h-1 bg-[#C9A84C] transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PillarsSection;
